export default __webpack_public_path__ + "static/media/no-content.5444f36c.svg";